<template>
  <div>
    <el-dialog
      title="生成打样项目"
      :visible.sync="dialogVisible"
      :before-close="close"
      :close-on-click-modal="false"
      width="350px"
    >
      <el-form ref="form" :model="formData" :rules="rules">
        <el-form-item label="项目分类" prop="prjCategoryCode">
          <dict-select
            ref="dict_prjcategory"
            v-model="formData.prjCategoryCode"
            url="/digitalCenter/common/dict/prjCategory"
            size="mini"
            placeholder="请选择项目分类"
            filterable
            clearable
          ></dict-select>
        </el-form-item>
        <el-form-item label="产品主分类" prop="masterCategoryCode">
          <dict-select
            v-model="formData.masterCategoryCode"
            url="/digitalCenter/common/dict/masterCategory"
            size="mini"
            placeholder="请选择产品主分类"
            filterable
            clearable
          ></dict-select>
        </el-form-item>
        <el-form-item label="打样类型" prop="sampleType" v-show="sampleTypeVisible">
          <el-radio-group size="mini" v-model="formData.sampleType">
            <el-radio label="S">样品打样</el-radio>
            <el-radio label="M">面料打样</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset">
<!--          <d2-icon name="refresh" />-->
          重 置
        </el-button>
        <el-button type="primary" size="mini" @click="save">
<!--          <d2-icon name="save" />-->
          保 存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { productBuildProject } from '@api/projectManager/infoProduct'
export default {
  data () {
    return {
      dialogVisible: false,
      sampleTypeVisible: false,
      formData: {
        prjCategoryCode: '',
        masterCategoryCode: '',
        sampleType: 'S',
        prjCode: '',
        prjProductCode: ''
      },
      rules: {
        prjCategoryCode: [
          { required: true, message: '请选择项目分类', trigger: 'change' }
        ],
        masterCategoryCode: [
          { required: true, message: '请选择产品主分类', trigger: 'change' }
        ],
        sampleType: [
          { required: true }
        ]
      }
    }
  },
  watch: {
    'formData.prjCategoryCode' (val) {
      if (!val) {
        this.sampleTypeVisible = false
        return
      }
      let selected = this.$refs.dict_prjcategory.selected
      this.sampleTypeVisible = selected.isSample === 'Y'
    }
  },
  methods: {
    load (prjCode, prjProductCode) {
      this.formData.prjCode = prjCode
      this.formData.prjProductCode = prjProductCode
      this.dialogVisible = true
    },
    save () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.buildProjectInfoProductApi(this.formData).then(res => {
            this.$message({
              showClose: true,
              message: '生成成功',
              type: 'success'
            })
            this.$refs.form.resetFields()
            this.dialogVisible = false
            // 通知父组件保存成功
            this.$emit('success')
          })
        } else {
          return false
        }
      })
      return ''
    },
    close () {
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    reset () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    }
  }
}
</script>
